import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const InformPriceTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const {adPrice, agreedPrice, buyerName} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionInformPriceModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCircleCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t(`COMMON.PRICE_SENT`)}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionInformPriceModal-modalChildren">
                  <div className="mt-TransactionInformPriceModal-description">
                    {i18n.t('VEHICLE_TRANSACTION.AGREE_PRICE.MODAL_TEXT', {buyerName})}
                  </div>
                  <div className="mt-TransactionInformPriceModal-priceWrapper">
                    <div className="mt-TransactionInformPriceModal-adPrice">
                      <span className="mt-TransactionInformPriceModal-adPriceLabel">
                        {i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.AD_PRICE')}
                      </span>
                      <span className="mt-TransactionInformPriceModal-adPriceValue">
                        {adPrice ? i18n.c(Number(adPrice)) : null}
                      </span>
                    </div>
                    <div className="mt-TransactionInformPriceModal-agreedPrice">
                      <span className="mt-TransactionInformPriceModal-agreedPriceLabel">
                        {i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.AGREED_PRICE')}
                      </span>
                      <span className="mt-TransactionInformPriceModal-agreedPriceValue">
                        {agreedPrice ? i18n.c(Number(agreedPrice)) : null}
                      </span>
                    </div>
                  </div>
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.AGREE_PRICE.MODAL_TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
